import type { StructuralPassFailRow } from '@models/interfaces';
import type { StructuralStatus } from './structural-pass-fail.constants';
import {
  STRUCTURAL_STATUS_COLORS,
  STRUCTURAL_STATUS_LABELS,
} from './structural-pass-fail.constants';

export const getStructuralStatus = ({
  structuralAdequate,
  structuralRequired,
}: Pick<
  StructuralPassFailRow,
  'structuralAdequate' | 'structuralRequired'
>): StructuralStatus => {
  if (structuralRequired !== true) {
    return 'notRequired';
  }

  if (structuralAdequate === true) {
    return 'pass';
  }

  if (structuralAdequate === false) {
    return 'fail';
  }

  return 'pending';
};

export const getStructuralStatusLabel = (
  status?: StructuralStatus | null,
): string => (status ? STRUCTURAL_STATUS_LABELS[status] : '');

export const getStructuralStatusClassName = (
  status?: StructuralStatus | null,
): string =>
  [
    'prov-structural-pass-fail-report__status',
    status
      ? `prov-structural-pass-fail-report__status--${status}`
      : 'prov-structural-pass-fail-report__status--unknown',
  ].join(' ');

export const getStructuralStatusColor = (
  status?: StructuralStatus | null,
): string => (status ? STRUCTURAL_STATUS_COLORS[status] : '#949494');
